"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconDisability = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Disability" }, props),
        react_1.default.createElement("title", null, "Disability"),
        react_1.default.createElement("path", { d: "M60 111.429h51.429C111.429 83.025 88.404 60 60 60v51.429z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M60 111.429H8.571C8.571 83.025 31.596 60 60 60v51.429z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M60 54.279c12.622 0 22.854-10.232 22.854-22.854S72.622 8.571 60 8.571 37.147 18.803 37.147 31.425 47.378 54.279 60 54.279z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M74.41 111.429c7.822 0 14.165-6.397 14.165-14.283 0-7.885-6.343-14.282-14.164-14.282H60v28.543l14.41.022z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M8.571 111.429H60V60", fill: "#000" })));
};
exports.default = BrandIconDisability;
